import React from 'react';
import { Phone, Mail, Clock, Send } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { faqItems } from '../data/mock';

const ContactSection = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    // Form submission would be handled here
    alert('Message envoyé ! Nous vous répondrons rapidement.');
  };

  return (
    <section id="contact" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-amber-600 font-semibold text-sm uppercase tracking-wider mb-3">
            Contactez-nous
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Une Question ?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            N'hésitez pas à nous contacter pour toute question
            ou pour passer une commande.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div className="bg-gradient-to-br from-amber-50 to-white rounded-2xl p-8 lg:p-10 border border-amber-100">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              Envoyez-nous un message
            </h3>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                    Nom
                  </label>
                  <Input
                    id="name"
                    type="text"
                    placeholder="Votre nom"
                    className="w-full border-amber-200 focus:border-amber-500 focus:ring-amber-500"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                    Téléphone
                  </label>
                  <Input
                    id="phone"
                    type="tel"
                    placeholder="06 XX XX XX XX"
                    className="w-full border-amber-200 focus:border-amber-500 focus:ring-amber-500"
                  />
                </div>
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  Email
                </label>
                <Input
                  id="email"
                  type="email"
                  placeholder="votre@email.com"
                  className="w-full border-amber-200 focus:border-amber-500 focus:ring-amber-500"
                  required
                />
              </div>
              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                  Message
                </label>
                <Textarea
                  id="message"
                  placeholder="Votre message..."
                  rows={4}
                  className="w-full border-amber-200 focus:border-amber-500 focus:ring-amber-500 resize-none"
                  required
                />
              </div>
              <Button
                type="submit"
                className="w-full bg-amber-600 hover:bg-amber-700 text-white py-6 font-semibold"
              >
                <Send className="w-5 h-5 mr-2" />
                Envoyer le message
              </Button>
            </form>
          </div>

          {/* FAQ */}
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              Questions Fréquentes
            </h3>
            <Accordion type="single" collapsible className="space-y-4">
              {faqItems.map((item, index) => (
                <AccordionItem
                  key={index}
                  value={`item-${index}`}
                  className="bg-gradient-to-br from-amber-50/50 to-white rounded-xl border border-amber-100 px-6 overflow-hidden"
                >
                  <AccordionTrigger className="text-left font-semibold text-gray-900 hover:text-amber-700 hover:no-underline py-5">
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-600 pb-5 leading-relaxed">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>

            {/* Quick Contact */}
            <div className="mt-10 p-6 bg-amber-50 rounded-2xl border border-amber-100">
              <h4 className="font-bold text-gray-900 mb-4">Contact rapide</h4>
              <div className="space-y-3">
                <a
                  href="tel:0141552585"
                  className="flex items-center gap-3 text-gray-700 hover:text-amber-700 transition-colors"
                >
                  <Phone className="w-5 h-5 text-amber-600" />
                  <span className="font-medium">01 41 55 25 85</span>
                </a>
                <div className="flex items-center gap-3 text-gray-600">
                  <Clock className="w-5 h-5 text-amber-600" />
                  <span>Ouvert tous les jours jusqu'à 23:30</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
